import React from 'react'
import PageLayout from 'layouts/PageLayout'
import EmptyHeader from 'containers/EmptyHeader'
import { LoadingState } from '@sketch/components'
import Footer from 'components/Footer'

export const SsoLoadingPage = () => (
  <PageLayout header={<EmptyHeader />} footer={<Footer />}>
    <LoadingState />
  </PageLayout>
)
